import React, { Component, createRef } from 'react';
import { Button, Dropdown, Popup } from 'semantic-ui-react';
import { assignRequestToManager } from 'services/Manager';
import './ServiceRequestAssignment.less';


const initialState = {
    showRequestAssignPopup: false,
    managerUsers: [],
    selectedManagerUserID: 0,
    newManagerUserID: 0,
    disableAssignButton: true,
    selectedManagerUser: {}
}

class ServiceRequestAssignment extends Component {

    constructor(props) {
        super(props);
        this.requestAssignmentPopupContextRef = createRef();
        this.state = initialState;
    }

    componentDidMount() {
        this.loadManagerUsers();
        this.setState({selectedManagerUserID: this.props.request.sbr.assignedUserID, newManagerUserID: this.props.request.sbr.assignedUserID});
    }

    loadManagerUsers = () => {
        const { managerUsers } = this.props;
            
        const mu = _.find(managerUsers, u => u.userID == this.props.request.sbr.assignedUserID);  
        this.setState({ selectedManagerUser: mu ? mu : {} });

        if (managerUsers && managerUsers.length > 0) {
            const users = _.map(managerUsers, u => {
                if (this.state.selectedManagerUserID) {
                    if (this.state.selectedManagerUserID == u.userID) {
                        this.setState({ disableAssignButton: true });
                    }
                }
                return { text: `${u.firstName} ${u.lastName ? u.lastName : ''}`, value: u.userID };
            })
            this.setState({ managerUsers: users });
        }
    }

    componentDidUpdate(prevProps){
        console.log("did update...!!!")
        console.log("prevProps", prevProps);
        console.log("this.props", this.props);
        
        if(prevProps.managerUsers != this.props.managerUsers){
            console.log("did update inside...!!!")
            this.loadManagerUsers();
        }
    }

    onAssignClick = () => {
        this.setState({showRequestAssignPopup: true});
    }

    onRequestAssignmentPopupClose = () => {
        this.setState({showRequestAssignPopup: false, newManagerUserID: this.state.selectedManagerUserID, disableAssignButton: true});
    }

    onManagerSelect = (e, data) => {
        let disableAssignButton = false;
        
        if(data.value == this.state.selectedManagerUserID) {
            disableAssignButton = true;
        }        
        this.setState({newManagerUserID: data.value, disableAssignButton: disableAssignButton});
    }

    onAssignButtonClick = async () => {
        const res = await assignRequestToManager(this.props.request.sbr.singleBuyerRequestID, this.state.newManagerUserID);
        if(res.resStatus == 200){
            this.setState({showRequestAssignPopup: false, selectedManagerUserID: this.state.newManagerUserID, disableAssignButton: true}, () => {
                const { managerUsers } = this.props;
                console.log("managerUsers ," , managerUsers);
                console.log("newManagerUserID", this.state.newManagerUserID);
                const mu = _.find(managerUsers, u => u.userID == this.state.newManagerUserID);  
                console.log("this.state" , this.state);
                console.log("mu," , mu);
                this.setState({ selectedManagerUser: mu ? mu : {} });
                if (this.props.onAssignmentComplete) {
                    let notificationMsg = "";
                    if(mu)
                    {
                        notificationMsg = `Assigned to ${mu.firstName}`;
                    }else 
                    {
                        notificationMsg = `Assigned to selected manager`;
                    }
                    this.props.onAssignmentComplete('success', notificationMsg, this.state.newManagerUserID);
                }
            })
        }
        else{
            if(this.props.onAssignmentComplete){
                
                this.props.onAssignmentComplete('error', res.message);
            }
        }
    }

    render() {
        return <div className='service-request-assignment-container'>
            <Popup className="request-assignment-popup" context={this.requestAssignmentPopupContextRef} open={this.state.showRequestAssignPopup} onClose={this.onRequestAssignmentPopupClose}
                        position='bottom center' 
                        offset={[0, 0]}
                    >   
                    
                        <Popup.Content>
                            <div >
                                <Dropdown placeholder='Select Manager' className="request-assign-dropdown" options={this.state.managerUsers} 
                                onChange={this.onManagerSelect}
                                value={this.state.newManagerUserID}
                                />
                            </div>
                            
                            <button className='request-assign-button' onClick={this.onAssignButtonClick} disabled={this.state.disableAssignButton}>Assign</button>
                            
                        </Popup.Content>
                    </Popup>
            {!this.state.selectedManagerUserID && this.props.requestAssignmentEnabled /*&& !this.props.request.sbr.isAccepted*/ ?
                <div className='assign-action-only' onClick={this.onAssignClick} ref={this.requestAssignmentPopupContextRef}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="46.938" height="42.695" viewBox="0 0 46.938 42.695">
                        <defs>
                            <clipPath id="clip-path">
                                <rect id="Rectangle_8935" data-name="Rectangle 8935" width="46.938" height="42.695" fill="none" />
                            </clipPath>
                        </defs>
                        <g id="Assign-Icon" transform="translate(-1255.298 -25.668)">
                            <g id="Group_16166" data-name="Group 16166" transform="translate(1255.298 25.668)">
                                <g id="Group_16165" data-name="Group 16165" clip-path="url(#clip-path)">
                                    <path id="Path_29398" data-name="Path 29398" d="M23.42,42.693c-2.533,0-5.066,0-7.6,0a7.709,7.709,0,0,1-7.007-4.008c-2.606-4.417-5.141-8.875-7.679-13.331A7.643,7.643,0,0,1,1.162,17.3C3.7,12.881,6.243,8.466,8.823,4.074A7.807,7.807,0,0,1,15.916.015C20.93-.011,25.944,0,30.959.009a7.909,7.909,0,0,1,7.22,4.124q3.865,6.561,7.633,13.178a7.817,7.817,0,0,1-.056,8.173q-3.776,6.642-7.663,13.22a7.735,7.735,0,0,1-7.022,3.987c-2.55.006-5.1,0-7.651,0m.1-3.439c2.447,0,4.894-.013,7.341,0a4.741,4.741,0,0,0,4.471-2.579c2.4-4.22,4.8-8.434,7.263-12.616a4.891,4.891,0,0,0,0-5.384c-2.481-4.23-4.916-8.488-7.34-12.752a4.7,4.7,0,0,0-4.43-2.55c-4.911.018-9.823.006-14.735.007-.208,0-.417,0-.624.019a4.351,4.351,0,0,0-3.639,2.257Q8.013,12.28,4.207,18.907a4.521,4.521,0,0,0,0,4.833Q8,30.281,11.784,36.833a4.569,4.569,0,0,0,4.241,2.421q3.749,0,7.5,0" transform="translate(0 0)" />
                                    <path id="Path_29399" data-name="Path 29399" d="M156.871,217.105q-3.46,0-6.921,0c-.729,0-1-.266-1-1.006a28.022,28.022,0,0,1,.056-3.429,5.532,5.532,0,0,1,5.164-4.869,45.465,45.465,0,0,1,5.717.028,5.551,5.551,0,0,1,4.891,4.854c.11,1.17.084,2.355.08,3.533,0,.618-.33.889-.967.889q-3.513,0-7.025,0" transform="translate(-133.395 -186.058)" />
                                    <path id="Path_29400" data-name="Path 29400" d="M188.594,104.582a4.818,4.818,0,1,1-9.636.02,4.818,4.818,0,1,1,9.636-.02" transform="translate(-160.293 -89.366)" />
                                </g>
                            </g>
                        </g>
                    </svg>
                    
                </div> : <div className='assgined-user-action' {...{
                    onClick: /*!this.props.request.sbr.isAccepted ? this.onAssignClick : null,*/ this.props.requestAssignmentEnabled ? this.onAssignClick : null,
                    ref: /*!this.props.request.sbr.isAccepted ? this.requestAssignmentPopupContextRef : null*/ this.requestAssignmentPopupContextRef
                }}>
                    
                    <div className='name-action-container'>
                        {this.props.requestAssignmentEnabled  && <div className='action'>
                            <svg className='image' xmlns="http://www.w3.org/2000/svg" width="46.938" height="42.695" viewBox="0 0 46.938 42.695">
                                <defs>
                                    <clipPath id="clip-path">
                                        <rect id="Rectangle_8935" data-name="Rectangle 8935" width="46.938" height="42.695" fill="none" />
                                    </clipPath>
                                </defs>
                                <g id="Assign-Icon" transform="translate(-1255.298 -25.668)">
                                    <g id="Group_16166" data-name="Group 16166" transform="translate(1255.298 25.668)">
                                        <g id="Group_16165" data-name="Group 16165" clip-path="url(#clip-path)">
                                            <path id="Path_29398" data-name="Path 29398" d="M23.42,42.693c-2.533,0-5.066,0-7.6,0a7.709,7.709,0,0,1-7.007-4.008c-2.606-4.417-5.141-8.875-7.679-13.331A7.643,7.643,0,0,1,1.162,17.3C3.7,12.881,6.243,8.466,8.823,4.074A7.807,7.807,0,0,1,15.916.015C20.93-.011,25.944,0,30.959.009a7.909,7.909,0,0,1,7.22,4.124q3.865,6.561,7.633,13.178a7.817,7.817,0,0,1-.056,8.173q-3.776,6.642-7.663,13.22a7.735,7.735,0,0,1-7.022,3.987c-2.55.006-5.1,0-7.651,0m.1-3.439c2.447,0,4.894-.013,7.341,0a4.741,4.741,0,0,0,4.471-2.579c2.4-4.22,4.8-8.434,7.263-12.616a4.891,4.891,0,0,0,0-5.384c-2.481-4.23-4.916-8.488-7.34-12.752a4.7,4.7,0,0,0-4.43-2.55c-4.911.018-9.823.006-14.735.007-.208,0-.417,0-.624.019a4.351,4.351,0,0,0-3.639,2.257Q8.013,12.28,4.207,18.907a4.521,4.521,0,0,0,0,4.833Q8,30.281,11.784,36.833a4.569,4.569,0,0,0,4.241,2.421q3.749,0,7.5,0" transform="translate(0 0)" />
                                            <path id="Path_29399" data-name="Path 29399" d="M156.871,217.105q-3.46,0-6.921,0c-.729,0-1-.266-1-1.006a28.022,28.022,0,0,1,.056-3.429,5.532,5.532,0,0,1,5.164-4.869,45.465,45.465,0,0,1,5.717.028,5.551,5.551,0,0,1,4.891,4.854c.11,1.17.084,2.355.08,3.533,0,.618-.33.889-.967.889q-3.513,0-7.025,0" transform="translate(-133.395 -186.058)" />
                                            <path id="Path_29400" data-name="Path 29400" d="M188.594,104.582a4.818,4.818,0,1,1-9.636.02,4.818,4.818,0,1,1,9.636-.02" transform="translate(-160.293 -89.366)" />
                                        </g>
                                    </g>
                                </g>
                            </svg>
                        </div> }
                        <div className='text'>
                            <div className='name'>
                                { this.state.selectedManagerUser && 
                                    this.state.selectedManagerUser.firstName ? this.state.selectedManagerUser.firstName : 'N/A'}
                            </div>    
                        </div>
                    </div>
                </div>
            }
        </div>
    }
}

export default ServiceRequestAssignment;
